import React, { useMemo } from 'react'
import { PREFERENCES } from '../../user/constants'

import { useIncidentsFetch } from '../../incidents/hooks'
import { useAILayersFetch } from '../../aiLayers/hooks'
import { useCrimeCategoriesFetch } from '../../crimeCategories/hooks'
import { useUserPreferencesFetch, useUserPreference } from '../../user/hooks'
import { useOverlaysFetch } from '../../overlays/hooks'
import { useBuffersFetch } from '../../buffers/hooks'

import BaseLayout from '../../common/components/BaseLayout'

import Tab from '../../tabs/components/Tab'
import TabMenu from '../../tabs/components/TabMenu'
import TabPanel from '../../tabs/components/TabPanel'
import TabPanelContainer from '../../tabs/components/TabPanelContainer'

import OverlayPanel from '../../overlays/components/OverlayPanel'
import IncidentPanel from '../../incidents/components/IncidentPanel'
import IncidentLayer from '../../map/components/IncidentLayer'
import UserPanel from '../../user/components/UserPanel'

import Map from '../../map/components/Map'
import Zoom from '../../map/components/Zoom'
import BasemapToggle from '../../map/components/BasemapToggle'
import MeasurementTool from '../../map/components/MeasurementTool'
import Compass from '../../map/components/Compass'
import AILayer from '../../map/components/AILayer'
import TrafficLayer from '../../map/components/TrafficLayer'
import BufferLayer from '../../map/components/BufferLayer'
import OverlayLayer from '../../map/components/OverlayLayer'

import styles from './MainLayout.module.css'

const MainLayout = () => {
  useIncidentsFetch() // Run the incident fetch loop
  useAILayersFetch() // fetch the list of ai layers
  useCrimeCategoriesFetch() // fetch the list of crime categories
  useUserPreferencesFetch() // fetch user's preferences
  useOverlaysFetch() // fetch the available overlays
  useBuffersFetch() // fetch the default buffers when an incident is selected

  const basemap = useUserPreference(PREFERENCES.DEFAULT_BASEMAP) || 'streets-vector'

  const mapPadding = useMemo(
    () => ({
      top: 60,
      left: 460,
      right: 10,
      bottom: 20,
    }),
    []
  )

  return (
    <BaseLayout title="Command Central">
      <div className={styles.tabBar}>
        <TabMenu>
          <Tab path="/commandCentral/userMenu" icon="fa fa-user" />
          <Tab
            path="/commandCentral/incidentList"
            defaultPath="/commandCentral"
            icon="fa fa-list-ul"
          />
          <Tab path="/commandCentral/toggleLayers" icon="fas fa-layer-group" />
        </TabMenu>
      </div>
      <div className={styles.sideBar}>
        <TabPanelContainer>
          <TabPanel path="/commandCentral/userMenu">
            <UserPanel />
          </TabPanel>
          <TabPanel path="/commandCentral/toggleLayers">
            <OverlayPanel />
          </TabPanel>
          <TabPanel path="/commandCentral/incidentList">
            <IncidentPanel />
          </TabPanel>
          <TabPanel>
            {/*Default Panel */}
            <IncidentPanel />
          </TabPanel>
        </TabPanelContainer>
      </div>
      <Map basemap={basemap} padding={mapPadding}>
        <BasemapToggle
          position="top-right"
          next={basemap === 'streets-vector' ? 'satellite' : 'streets-vector'}
        />
        <MeasurementTool position="bottom-right" />
        <Compass position="bottom-right" />
        <Zoom position="bottom-right" />
        <IncidentLayer />
        <AILayer />
        <TrafficLayer />
        <BufferLayer />
        <OverlayLayer />
      </Map>
    </BaseLayout>
  )
}

export default MainLayout
